const versionNumber = "2.4.4";

export default versionNumber;
